// routes/buildProtectedRoutes.js
import { Navigate } from 'react-router-dom';
import RequireAuth from 'components/RequireAuth';

export function buildProtectedRoutes(routes = []) {
  return routes.map((route) => {
    if (route.children) {
      return {
        ...route,
        children: buildProtectedRoutes(route.children)
      };
    }

    return {
      ...route,
      element: (
        <RequireAuth allowedRoles={route.allowedRoles} featureCode={route.featureCode}>
          {route.element}
        </RequireAuth>
      )
    };
  });
}
